var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCancel({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#F3F4F6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.1899 15.1889C15.434 14.9448 15.8298 14.9449 16.0738 15.189L20.0003 19.1161L23.9283 15.1889C24.1724 14.9448 24.5681 14.9449 24.8122 15.189C25.0562 15.4331 25.0562 15.8288 24.8121 16.0728L20.8845 19.9997L24.8121 23.9273C25.0562 24.1713 25.0562 24.5671 24.8121 24.8111C24.568 25.0552 24.1723 25.0552 23.9282 24.8111L20.001 20.8839L16.0738 24.8111C15.8297 25.0552 15.434 25.0552 15.1899 24.8111C14.9458 24.5671 14.9458 24.1713 15.1899 23.9273L19.1167 20.0004L15.1899 16.0728C14.9458 15.8287 14.9458 15.4329 15.1899 15.1889Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancel);
export default __webpack_public_path__ + "static/media/cancel.a2407646bf43f66fba92e239373efd0c.svg";
export { ForwardRef as ReactComponent };